import React, { memo, useCallback, useContext, useEffect, useRef } from 'react';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import { isArrayLike } from 'mobx';
import { Tooltip as LabelTooltip } from '../core/enum';
import isOverflow from '../overflow-tip/util';
import { hide, show } from '../tooltip/singleton';
const FormItemLabel = function FormItemLabel(props) {
    const { className, rowSpan, style, tooltip, children, help } = props;
    const { getTooltipTheme, getTooltipPlacement } = useContext(ConfigContext);
    const tooltipRef = useRef(false);
    const handleMouseEnter = useCallback((e) => {
        const { currentTarget } = e;
        if (tooltip === LabelTooltip.always || (tooltip === LabelTooltip.overflow && isOverflow(currentTarget))) {
            show(currentTarget, {
                title: children,
                theme: getTooltipTheme('label'),
                placement: getTooltipPlacement('label'),
            });
            tooltipRef.current = true;
        }
        else if (isArrayLike(tooltip)) {
            const tooltipType = tooltip[0];
            const labelTooltipProps = tooltip[1] || {};
            const duration = (labelTooltipProps.mouseEnterDelay || 0.1) * 1000;
            if (tooltipType === LabelTooltip.always || (tooltipType === LabelTooltip.overflow && isOverflow(currentTarget))) {
                show(currentTarget, {
                    theme: getTooltipTheme('label'),
                    placement: getTooltipPlacement('label'),
                    title: labelTooltipProps.title ? labelTooltipProps.title : children,
                    ...labelTooltipProps,
                }, duration);
                tooltipRef.current = true;
            }
        }
    }, [tooltip, children, tooltipRef]);
    const handleMouseLeave = useCallback(() => {
        if (tooltipRef.current) {
            hide();
            tooltipRef.current = false;
        }
    }, [tooltipRef]);
    useEffect(() => () => {
        if (tooltipRef.current) {
            hide();
            tooltipRef.current = false;
        }
    }, [tooltipRef]);
    return (React.createElement("td", { className: className, rowSpan: rowSpan, style: style },
        React.createElement("label", null,
            React.createElement("span", { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, children),
            help)));
};
FormItemLabel.displayName = 'FormItemLabel';
export default memo(FormItemLabel);
